import {ValueObject} from '@s-ui/domain'

export class ContactDetailsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Object} deps.adId
   * @param {Object} deps.message
   * @param {Object} deps.name
   * @param {Object} deps.email
   * @param {Object} deps.phone
   * @param {Object} deps.date
   * @param {Object} deps.zipCode
   */
}
